import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { PRICE } from '../../data/content';
export function Guarantee() {
  return <section className="w-full bg-cream px-4 py-12 sm:px-6 sm:py-20" data-id="element-245" data-mp="24n85qg2t0cwr">
      <div className="mx-auto max-w-2xl rounded-3xl border border-kidney/30 bg-white px-5 py-8 text-center sm:px-10 sm:py-12" data-id="element-246" data-mp="24lx3wlsx5f8a">
        <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-kidney-light" data-id="element-247" data-mp="2ed01veqjxe3c">
          <ShieldCheckIcon className="h-7 w-7 text-kidney-dark" aria-hidden="true" data-id="element-248" data-mp="2jbujidcs8wlv" />
        </span>
        <p className="mt-4 text-[11px] font-extrabold uppercase tracking-[0.2em] text-kidney-dark" data-id="element-249" data-mp="2obgxip0fqgvq">
          Garanzia di 7 giorni
        </p>
        <h2 className="mt-3 font-display text-[26px] font-extrabold leading-tight text-navy-deep sm:text-4xl" data-id="element-250" data-mp="2sbhplcggiql9">
          Esploralo. Utilizzalo. Decidi tu.
        </h2>

        <div className="mt-5 flex flex-col gap-3 text-[14.5px] leading-relaxed text-navy/75 sm:text-base" data-id="element-251" data-mp="xy89v2xbi8uk">
          <p data-id="element-252" data-mp="3slol54ewsa80">Non devi fidarti semplicemente delle nostre parole.</p>
          <p data-id="element-253" data-mp="3nuq76bhe7o7x">
            Hai 7 giorni per accedere al sistema, consultare i percorsi clinici,
            esplorare i volumi e verificare se Percorso Malattia Renale™ ti offre la
            chiarezza pratica che stai cercando.
          </p>
          <p data-id="element-254" data-mp="3dxlju8bt9mpj">
            Se decidi che non fa per te, contattaci entro il periodo di garanzia e
            procederemo al rimborso secondo la nostra politica.
          </p>
          <p className="font-bold text-navy-deep" data-id="element-255" data-mp="afad1m3bmuhj">
            Nessun impegno a lungo termine. Nessun abbonamento. Nessun rischio.
          </p>
        </div>

        <div className="mx-auto mt-8 max-w-md" data-id="element-256" data-mp="5itlsj0ts008">
          <CtaButton label="Voglio provarlo senza rischi" sub={`Accesso immediato per ${PRICE} • Protetto dalla garanzia di 7 giorni`} data-id="element-257" data-mp="ifbsvfnyfzk" />
        </div>
      </div>
    </section>;
}